import { PRIVILEGE } from "constants/privilege";
import { useCallback, useEffect } from "react";
import Avatar from "react-avatar";
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom";
import { fetchBrandList } from "slices/brand/list/thunk";
import { AppDispatch, RootState } from "store"
import AccessControl from "wrappers/AccessControl";
import Skeleton from "react-loading-skeleton";
import StarIcon2 from "assets/icons/mono/StarIcon2";
import EditIcon from "assets/icons/mono/EditIcon";
import useDocumentTitle from "hooks/useDocumentTitle";
import InfiniteScroll from "react-infinite-scroll-component";

const Index = () => {

    const dispatch: AppDispatch = useDispatch();

    useDocumentTitle("Brands");

    const { items: brands, has_more, page, loading, error } = useSelector((state: RootState) => state.brandList);

    const fetchBrands = useCallback(async (page: number, force: boolean = false) => {
        dispatch(fetchBrandList({ page, force }));
    }, [dispatch])

    useEffect(() => {
        fetchBrands(1);
    }, [fetchBrands])

    const nextPage = () => {
        if (has_more) {
            const nextPageNumber = page + 1;
            fetchBrands(nextPageNumber);
        }
    }

    return (
        <div className="page">
            <div className="page-heading">
                <div className="content pt-0 d-flex w-100 justify-content-between align-items-center">
                    <h4 className="page-title">Brands</h4>
                    <AccessControl privilege={PRIVILEGE.BRAND.BRAND.CREATE}>
                        <Link to={{ pathname: '/brand/create' }} className="theme-btn theme-btn-md link-as-btn btn-gradient"><StarIcon2 className='me-2' /> Create Brand</Link>
                    </AccessControl>
                </div>
            </div>
            <div className="content">
                {
                    brands.length > 0 &&
                    <div className="card">
                        <div className="card-body p-0 m-0 table-responsive">
                            <InfiniteScroll
                                dataLength={brands.length}
                                next={nextPage}
                                hasMore={has_more}
                                loader={<></>}
                                className="w-100"
                            >
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th className="text-start px-5">Website</th>
                                            <th>Instagram Handle</th>
                                            <th>Campaigns</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            brands.map((brand, i) => {
                                                return (
                                                    <tr className="border-bottom-1 px-3" key={i}>
                                                        <td className="w-25">
                                                            <div className="py-4">
                                                                <div className="d-flex justify-content-start align-items-center gap-3 border-right-dashed td-content">
                                                                    {
                                                                        brand.img_url ? <div className="brand-logo bg-image bgc-white" style={{ backgroundImage: `url(${brand?.img_url})` }} /> : <Avatar size='36' round={'4px'} name={brand.name} />
                                                                    }
                                                                    <span className="user-name">{brand.name}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="">
                                                            <div className="py-4">
                                                                <div className="d-flex justify-content-start align-items-center gap-2 border-right-dashed td-content px-5">
                                                                    <a target="_blank" rel="noreferrer" href={brand.website_url ?? '#'} className="">{brand.website_url}</a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="py-4">
                                                                <div className="d-flex justify-content-center align-items-center gap-2 border-right-dashed td-content">
                                                                    {
                                                                        brand.ig_handle &&
                                                                        <a href={`https://instagram.com/${brand.ig_handle}`} target="_blank" rel="noreferrer" className="ig-logo"></a>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="table-action-column">
                                                            <div className="py-4">
                                                                <div className="d-flex justify-content-center align-items-center gap-2 border-right-dashed td-content">
                                                                    <Link to={{ pathname: '/campaign', search: `brand=${brand.id}` }}>{brand.campaign_count}</Link>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="table-action-column">
                                                            <div className="py-4">
                                                                <div className="d-flex justify-content-center align-items-center gap-2 td-content">

                                                                    <AccessControl privilege={PRIVILEGE.BRAND.BRAND.EDIT}>
                                                                        <Link to={{ pathname: `/brand/${brand.id}/edit` }}><EditIcon /></Link>
                                                                    </AccessControl>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {
                                            loading &&
                                            Array.from({ length: 10 }).map((_, i) => {
                                                return (
                                                    <tr>
                                                        <td><Skeleton /></td>
                                                        <td><Skeleton /></td>
                                                        <td><Skeleton /></td>
                                                        <td><Skeleton /></td>
                                                        <td><Skeleton /></td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {
                                            !loading && error &&
                                            <tr>
                                                <td colSpan={5}>
                                                    <div className="d-flex py-3 justify-content-center align-items-center">
                                                        <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </InfiniteScroll>
                        </div>
                    </div>
                }
                {
                    !loading && brands.length === 0 &&
                    <div className="d-flex w-100 justify-content-center align-items-center">
                        <div className="length-zero">
                            <h3>Currently there is no brand in your list</h3>
                        </div>
                    </div>
                }
            </div>
        </div>

    )
}

export default Index